'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('./users/index.js');
var index$1 = require('./wallet/index.js');
var index$2 = require('./configs/index.js');
var index$3 = require('./games/index.js');
var index$4 = require('./translations/index.js');
var index$5 = require('./promotions/index.js');
var index$6 = require('./pages/index.js');
var index$7 = require('./signup/index.js');
var index$8 = require('./maintenance/index.js');
var index$9 = require('./messages/index.js');
var index$a = require('./bonuses/index.js');
var index$b = require('./offers/index.js');
var index$c = require('./responsiblegaming/index.js');
var index$d = require('./rewards/index.js');
var index$e = require('./competitions/index.js');
var index$f = require('./faqs/index.js');
var index$g = require('./faqsCategories/index.js');
var index$h = require('./system/index.js');
var index$i = require('./lottery/index.js');
var index$j = require('./loyalty/index.js');
var index$k = require('./sitefeatures/index.js');
var index$l = require('./gamification/index.js');
var index$m = require('./geoComply/index.js');
var index$n = require('./externalServices/index.js');
var index$o = require('./navigations/index.js');

class Adapter {
  constructor() {
    this.bonuses = new index$a.Bonuses();
    this.competitions = new index$e.Competitions();
    this.users = new index.Users();
    this.wallet = new index$1.Wallet();
    this.configs = new index$2.Configs();
    this.games = new index$3.Games();
    this.translations = new index$4.Translations();
    this.promotions = new index$5.Promotions();
    this.pages = new index$6.Pages();
    this.signup = new index$7.Signup();
    this.maintenance = new index$8.Maintenance();
    this.messages = new index$9.Messages();
    this.navigations = new index$o.Navigations();
    this.offers = new index$b.Offers();
    this.rewards = new index$d.Rewards();
    this.responsibleGaming = new index$c.ResponsibleGaming();
    this.faqs = new index$f.FAQs();
    this.faqsCategories = new index$g.FAQsCategories();
    this.system = new index$h.System();
    this.lottery = new index$i.Lottery();
    this.loyalty = new index$j.Loyalty();
    this.sitefeatures = new index$k.SiteFeatures();
    this.gamification = new index$l.Gamification();
    this.geoComply = new index$m.GeoComply();
    this.externalServices = new index$n.ExternalServices();
  }
}
const adapter = new Adapter();

exports.adapter = adapter;
